import { render, staticRenderFns } from "./TaskNameRenderer.vue?vue&type=template&id=4e5ece27"
import script from "./TaskNameRenderer.vue?vue&type=script&lang=js"
export * from "./TaskNameRenderer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports